import { render, staticRenderFns } from "./radish-add-page.vue?vue&type=template&id=e6fe7bfc"
import script from "./radish-add-page.vue?vue&type=script&lang=js"
export * from "./radish-add-page.vue?vue&type=script&lang=js"
import style0 from "./radish-add-page.vue?vue&type=style&index=0&id=e6fe7bfc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports